import { recordStartupPhase } from 'bootstrap/startup-diagnostics';

/**
 * Displays an error page when the application fails to load the environment configuration.
 * This is shown before Angular bootstraps, so it uses plain DOM manipulation.
 */
export function showBootstrapError(error: Error): void {
  recordStartupPhase('startup-complete');

  const errorContainer = document.createElement('div');
  errorContainer.id = 'bootstrap-error';
  errorContainer.innerHTML = `
    <style>
      .load-app-error-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100vh;
        width: 100vw;
        background: #264252;
        color: #fff;
      }

      .load-app-error-content {
        width: 75%;
        max-width: 750px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      h1 {
        display: flex;
        gap: 15px;
        color: #fff;
      }

      button {
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
    </style>

    <div class="load-app-error-wrapper">
      <div class="load-app-error-content">
        <h1><span>⚠️</span> Unable to Load Application</h1>
        <p>
          We couldn't connect to the server to load the application configuration.
          Please check your internet connection and try again.
        </p>

        <button class="secondary" onclick="window.location.reload()">
          Try Again
        </button>

        <details class="error-details">
          <summary>Technical Details</summary>
          <pre>${escapeHtml(error.message)}</pre>
        </details>
      </div>
  </div>

  `;

  // Remove the loading indicator if present
  const appRoot = document.querySelector('app-root');
  if (appRoot) {
    appRoot.innerHTML = '';
  }

  document.body.appendChild(errorContainer);
}

/**
 * Escapes HTML to prevent XSS when displaying error messages
 */
function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
